import React, { useEffect, useState } from "react";
import { no_giftcard } from "../../../Image/Index";
import { Link } from "react-router-dom";
import { giftCard, CountryRegions, giftCardUpdate } from "../../../actions/auth";
import SelectValidator from "../../partial/SelectValidator";
import { ValidatorForm } from "react-form-validator-core";
import Header from "../../layout/Header";
import { selectValueGetter } from "../../../utils/helper";
import CardViewModal from "./CardViewModal";
import swal from "sweetalert";

const GiftCardVoucher = () => {
    const [loader, setLoader] = useState(false);
    const [data, setData] = useState([]);
    const [isSelected, setIsSelected] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [code, setCode] = useState();
    const [formData, setFormData] = useState({
        cardsForUpdate: [],
        getCards: [],
    });
    const [country, setCountry] = useState();
    const [state, setState] = useState({
        selectedCountry: "",
        options: [],
    });
    const { selectedCountry, options } = state;
    const { cardsForUpdate, getCards } = formData;

    useEffect(() => {
        const fetchCountryRegions = async () => {
            setLoader(true);
            const token = JSON.parse(localStorage.getItem("token_gen"));
            let res = await CountryRegions(token?.access_token);
            const country = [];
            res?.map((val) => country.push({ value: val.name, label: val.displayName }));
            setState({ ...state, options: country });
            setLoader(false);
        };
        fetchCountryRegions();
    }, []);

    useEffect(() => {
        let tempIsSelected = [];
        let tempAllCards = [];
        if (data.length > 0) {
            data.filter((ele, i) => {
                tempAllCards.push({
                    id: ele.id,
                    client_id: ele.client_id,
                    country_id: ele.country_id,
                    is_selected: ele.is_selected,
                });
                if (ele.is_selected === true) {
                    tempIsSelected.push(ele.id);
                }
            });
        }
        setIsSelected(tempIsSelected);
        setFormData({ ...formData, cardsForUpdate: tempAllCards, getCards: tempAllCards });
    }, [data]);

    const fetch = async (country) => {
        setLoader(true);
        const merchantCode = localStorage.getItem("merchantcode");
        let response = await giftCard(merchantCode, country);
        setData(response);
        setLoader(false);
    };

    const onSelectChange = (e) => {
        setState({ ...state, selectedCountry: e.value });
        setCountry(e.label);
        fetch(e.value);
    };

    const handleSelect = (item) => {
        if (isSelected.includes(item.id)) {
            setIsSelected(isSelected.filter((id) => id !== item.id));
            setFormData((prevState) => ({
                ...prevState,
                cardsForUpdate: prevState.cardsForUpdate.map((ele) => {
                    if (ele.id === item.id) {
                        return {
                            ...ele,
                            is_selected: false,
                        };
                    }
                    return ele;
                }),
            }));
        } else {
            setFormData((prevState) => ({
                ...prevState,
                cardsForUpdate: prevState.cardsForUpdate.map((ele) => {
                    if (ele.id === item.id) {
                        return {
                            ...ele,
                            is_selected: true,
                        };
                    }
                    return ele;
                }),
            }));
            setIsSelected([...isSelected, item.id]);
        }
    };
    const handleViewModal = (item) => {
        setShowModal(true);
        setCode(item);
    };

    const onSubmit = async () => {
        setLoader(true);
        let body = cardsForUpdate;
        let response = await giftCardUpdate(body);
        if (response?.message?.data === "Details updated successfully") {
            fetch(selectedCountry);
            swal({
                position: "center",
                icon: "success",
                title: response?.message?.data,
                showConfirmButton: false,
                timer: 5000,
            });
        } else {
            swal({
                position: "center",
                icon: "error",
                title: response?.message?.data,
                showConfirmButton: false,
                timer: 5000,
            });
        }
        setLoader(false);
    };

    return (
        <>
            <Header name={"Gift Card"} />
            {loader && (
                <div className="mainPreloaderMain">
                    <div className="mainPreloader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            )}

            {/* <div className="dashboard__content">
                <div className="giftcard_mainbox">
                    <div className="gc_sidebar">
                        <h4>Country</h4>
                        <input type="text" />
                        <div className="">
                            <div className="">Country</div>
                        </div>
                    </div>
                    <div className="gc_contentbox">
                        <div className=""></div>
                    </div>
                </div>
            </div> */}
            <div className="dashboard__content">
                <div className="container-fluid">
                    <h5 className="gc_content">Explore a wide range of brand vouchers across different countries.</h5>
                    <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <ValidatorForm className="signUpPage__formSection" autoComplete="off" autoCapitalize="off" onSubmit={(e) => onSubmit(e)}>
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <SelectValidator placeholder="Select country" className="custom-ReactSelect bordered" name="country" value={selectValueGetter(options, selectedCountry)} options={options} onChange={onSelectChange} />
                                        </div>
                                    </div>
                                </div>
                                {data?.length > 0 && selectedCountry !== "contact us" && (
                                    <p>
                                        Showing all gift vouchers available in <b>{country}</b>
                                    </p>
                                )}
                            </ValidatorForm>
                        </div>
                    </div>
                </div>
            </div>

            <div className="campaignSelection__boxes">
                {country &&
                    (Array.isArray(data) && data.length > 0 ? (
                        <div className="row">
                            {data?.map((item) => (
                                <div className="col-sm-2 col-md-2 col-lg-2 col-xl-2" key={item.code}>
                                    <div className={isSelected && isSelected.includes(item.id) ? "giftcard_voucher_box selected_voucher" : "giftcard_voucher_box"}>
                                        <div className="gc_imagebox">
                                            <img src={item.image} alt="" />

                                            <div className="gc_overlay">
                                                <div className="gc_overlay_box">
                                                    <ul>
                                                        <li>
                                                            <Link to="" onClick={() => handleViewModal(item.code)}>
                                                                View Details
                                                            </Link>
                                                        </li>

                                                        <li>
                                                            <Link to="" onClick={() => handleSelect(item, "select")}>
                                                                {isSelected && isSelected.includes(item.id) ? "Un select" : "Select"}
                                                            </Link>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row giftcard_voucher_details">
                                            <div className="giftcard_voucher_title">
                                                <h5>{item.title}</h5>
                                            </div>
                                            <div className="giftcard_voucher_button">
                                                {isSelected && isSelected.includes(item.id) && (
                                                    <button type="checkbox" className="btn btn-primary" onClick={() => handleSelect(item, "unSelect")}>
                                                        <i className="fa-solid fa-check fa-solid fa-eye"></i>
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                            <div className="row" style={{ paddingBottom: "20px" }}>
                                <div className="col-sm-12  col-md-12 col-lg-12 col-xl-12">
                                    <div className="button-section" style={{ display: "flex", justifyContent: "flex-end" }}>
                                        <button type="submit" onClick={onSubmit} className="btn btn-primary" disabled={getCards.length === cardsForUpdate.length && getCards.every((e, i) => e.is_selected === cardsForUpdate[i].is_selected)}>
                                            Update
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="row">
                            <div className="col-md-4 offset-md-4">
                                <div className="no_giftcard_box">
                                    <img src={no_giftcard} className="" />
                                    <h6>There is no gift card available in your selected country</h6>
                                    <Link to="/contact-us" className="btn btn-outline-primary">
                                        Contact Novus Support
                                    </Link>
                                </div>
                            </div>
                        </div>
                    ))}
                {showModal && <CardViewModal show={showModal} close={() => setShowModal(false)} code={code} />}
            </div>
        </>
    );
};

export default GiftCardVoucher;
